import type { ApiPaginatedResponse } from '@_/types';
import type { UseInfiniteQueryOptions } from '@tanstack/react-query';
import type React from 'react';
import type { CommentThreadNode, CommentThreadNodeMap } from './types.ts';
import { createContext } from 'react';

export interface CommentThreadContextType<TComment> {
  addComments: (comments: TComment[], options?: { prepend?: boolean }) => void;
  canReply: boolean;
  commentComponent: React.ElementType<{ comment: TComment; pinned?: boolean }>;
  emptyMessage: React.ReactNode | undefined;
  fetchQueryArgs: (data: {
    parentCommentId: string | null;
  }) => Pick<UseInfiniteQueryOptions<ApiPaginatedResponse<TComment[]>>, 'queryFn' | 'queryKey'>;
  pinnedCommentId?: string;
  nodeMap: CommentThreadNodeMap<TComment>;
  rootNode: CommentThreadNode<TComment>;
}

export const CommentThreadContext = createContext<CommentThreadContextType<unknown> | null>(null);
